import script from "./SyncAppTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncAppTile.vue?vue&type=script&setup=true&lang=ts"

import "./SyncAppTile.vue?vue&type=style&index=0&id=37609427&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37609427"]])

export default __exports__